import { SystemStyleObject } from "@chakra-ui/react";

export const switchInputCss: SystemStyleObject = {
  opacity: 0,
  width: 0,
  height: 0,

  "&:checked + span": {
    backgroundColor: "#00535C",
  },

  "&:checked + span::before": {
    transform: "translateX(16px)",
  },
};

export const switchSliderCss: SystemStyleObject = {
  position: "absolute",
  cursor: "pointer",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "#E7E7E7",
  padding: "2px",
  borderRadius: "12px",
  transition: "background-color 0.3s",

  "&::before": {
    content: '""',
    position: "absolute",
    height: "16px",
    width: "16px",
    left: "2px",
    bottom: "2px",
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    boxShadow: "0px 1px 3px 0px #1018281A",
    transition: "transform 0.3s",
  },
};
